import {useOrderEditContext} from "../OrderEditContext";
import {useTranslation} from "react-i18next";
import {BasePopupProps, NameWithId} from "../../../../utils/Models";
import FlintRemoteDataComboBox from "../../../../components/controls/FlintRemoteDataComboBox";
import {ApiUrl_Customers_Get, ApiUrl_Orders_GetPrepareFor} from "../../../../utils/Endpoints";
import {useRef, useState} from "react";
import FlintButton from "../../../../components/controls/FlintButton";

export default function PrepareOrderForCompanyPopup(props: PrepareOrderForCompanyPopupProps) {
    const {t} = useTranslation();
    const {state, utils, handlers} = usePrepareOrderForCompanyPopup(props);

    return (
        <div className={"d-grid"}>
            <div className="alert alert-info text-center">{t("ORDER_PREPARE_FOR_INFO")}</div>
            <div className={"form-group"}>
                <FlintRemoteDataComboBox<NameWithId> baseUrl={ApiUrl_Orders_GetPrepareFor}
                                                     allowCustom={false}
                                                     value={state.selectedCustomer.get}
                                                     label={t("companyName")}
                                                     placeholder={t("ORDER_START_TYPING")}
                                                     onItemSelected={((customer) => {
                                                         handlers.handleCustomerSelected(customer);
                                                     })}/>
            </div>
            <div className={"form-group btn-section text-center"}>
                <FlintButton themeColor={"secondary"} onClick={props.OnCancelled} className={"me-2"}>{t("Cancel")}</FlintButton>
                <FlintButton onClick={handlers.handleApplyCustomer} disabled={state.selectedCustomer.get == null}>
                    {t("COMMON_APPLY")}
                </FlintButton>
            </div>
        </div>
    );
}

export interface PrepareOrderForCompanyPopupProps extends BasePopupProps<NameWithId> {

}

function usePrepareOrderForCompanyPopup(props: PrepareOrderForCompanyPopupProps) {
    const [selectedCustomer, setSelectedCustomer] = useState<NameWithId>()

    function handleCustomerSelected(customer: NameWithId): void {
        setSelectedCustomer(customer);
    }
    function handleApplyCustomer(){
        return props.OnConfirmedAndSaved(selectedCustomer);
    }
    return {
        state: {
            selectedCustomer: {get: selectedCustomer},
        },
        utils: {
            visibility: {},
        },
        handlers: {
            handleCustomerSelected,
            handleApplyCustomer
        },
    };
}
